import React, { useRef } from 'react'

// import Button from 'common/Button'

import { Swiper as SwiperContainer, SwiperSlide } from 'swiper/react'
import {
  // Autoplay,
  // Scrollbar,
  // Mousewheel,
  Navigation,
  Pagination,
} from 'swiper/modules'
import classNames from 'classnames'
import * as styles from './swiper.module.scss'

// import styles from '@/styles/components/common/swiper.module.scss'

// https://swiperjs.com/demos#infinite-loop

export default function Swiper({
  // navigation = false,
  // pagination = true,
  className = 'swiper-container-el',
  spaceBetween = 16,
  mobileSpaceBetween = 20,
  slidesPerView = 3,
  // offset = 0.05,
  offset = 0,
  mobileOffset = 0.1,
  mobileSlidesPerView = 1,
  slides = [],
  component: Component,
  options = {},
  breakpointsOptions = {},
  // scrollbarHide = false,
  // mousewheel = false,
  sliderBelow = false,
  breakpoints = {
    320: {
      slidesPerView: mobileSlidesPerView + mobileOffset,
      spaceBetween: mobileSpaceBetween,
    },
    680: {
      slidesPerView:
        slidesPerView === 'auto' ? 'auto' : mobileSlidesPerView + 1 + offset,
      spaceBetween,
    },
    1024: {
      slidesPerView: slidesPerView === 'auto' ? 'auto' : slidesPerView + offset,
      spaceBetween,
    },
    1470: {
      slidesPerView: slidesPerView === 'auto' ? 'auto' : slidesPerView,
      spaceBetween,
    },
    ...breakpointsOptions,
  },
}) {
  const nextRef = useRef(null)
  const prevRef = useRef(null)

  return (
    <div
      className={classNames('swiper-container', styles.swiper, className, {
        [styles.sliderBelow]: sliderBelow,
      })}
    >
      <div className="swiper-button-next" ref={nextRef} />
      <div className="swiper-button-prev" ref={prevRef} />

      <SwiperContainer
        modules={[Navigation, Pagination]}
        pagination={{
          // el: '.swiper-pagination',
          el: '.swiper-custom-pagination',
          clickable: true,
        }}
        navigation={{
          // enabled: true,
          // nextEl: `${className} .swiper-button-next`,
          // prevEl: `.swiper-button-prev`,
          nextEl: nextRef.current,
          prevEl: prevRef.current,
        }}
        onSwiper={(swiper) => {
          swiper.params.navigation.nextEl = nextRef.current
          swiper.params.navigation.prevEl = prevRef.current

          swiper.navigation.init()
          swiper.navigation.update()
        }}
        // scrollbar={{
        //   hide: scrollbarHide,
        //   draggable: true,
        // }}
        // mousewheel={mousewheel}

        spaceBetween={spaceBetween}
        slidesPerView={slidesPerView}
        breakpoints={breakpoints}
        {...options}
      >
        {slides.map((props, idx) => {
          return (
            <SwiperSlide
              key={idx}
              className={classNames({
                [styles.autoWidth]: slidesPerView === 'auto',
              })}
            >
              <Component {...props} />
            </SwiperSlide>
          )
        })}

        <div className={classNames(styles.swiperPagination)}>
          <div className="swiper-custom-pagination" />
        </div>
      </SwiperContainer>
    </div>
  )
}
